import React from "react"

import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation, Pagination, Autoplay } from "swiper/modules"
import DynamicImage from "../common/DynamicImage"
import { renderText } from "../common/renderText"
import { HighlightText } from "../common/HighlightText"

const WhatWeDo = ({ data }) => {
  return (
    <>
      <div className="case-study-area bg-fffbf5 ptb-70">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8" data-aos="fade-up">
              <div className="section-title">
                {data?.title && (
                  // <h2 dangerouslySetInnerHTML={{ __html: data.title }} />
                  <h2><HighlightText content={data.title} /></h2>
                )}
                {data?.description?.map((block, i) => {
                  if (block.type === "paragraph") {
                    return (
                      <p key={i}>
                        {block.children.map(c => c.text).join("")}
                      </p>
                    );
                  }
                  return null;
                })}
              </div>
            </div>
          </div>
          <Swiper
            navigation={true}
            pagination={{ clickable: true }}
            autoplay={{
              disableOnInteraction: true,
              pauseOnMouseEnter: true,
            }}
            modules={[Navigation, Pagination, Autoplay]}
            className="case-study-slides what-we-do-slides"
          >
            {data?.strategyContents?.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="single-case-study-item ptb-100">
                  <div className="container">
                    <div className="row align-items-center">
                      <div className="col-lg-6 col-md-12">
                        <div className="case-study-content">
                          {/* <h2 dangerouslySetInnerHTML={{ __html: item.title }}></h2> */}
                          <h2><HighlightText content={item.title} /></h2>
                          {/* {item?.description?.map((block, i) => {
                            if (block.type === "paragraph") {
                              return (
                                <p key={i}>
                                  {block.children.map(c => c.text).join("")}
                                </p>
                              );
                            }
                            return null;
                          })} */}
                           {item?.description?.map((block, index) => {
                                              switch (block.type) {
                                                case "paragraph":
                                                  return <p key={index}>{renderText(block.children)}</p>;
                          
                                                case "heading":
                                                  const Tag = `h${block.level}`;
                                                  return (
                                                    <Tag key={index} className="mt-4 mb-3">
                                                      <HighlightText content={block.children.map((c) => c.text).join("")} />
                                                    </Tag>
                                                  );
                                                case "list":
                                                  const ListTag =
                                                    block.format === "ordered" ? "ol" : "ul";
                          
                                                  return (
                                                    <ListTag key={index} className="features-text">
                                                      {block.children.map((item, i) => (
                                                        <li key={i}>
                                                            <i className="flaticon-tick"></i>
                                                            <span>
                                                              {item.children.map((child, j) => {
                                                                const isBold =
                                                                  child.bold ||
                                                                  child.marks?.some(
                                                                    (mark) => mark.type === "bold",
                                                                  );
                          
                                                                if (isBold) {
                                                                  return <b key={j}>{child.text}</b>;
                                                                }
                          
                                                                return child.text;
                                                              })}
                                                            </span>
                                                        </li>
                                                      ))}
                                                    </ListTag>
                                                  );
                          
                                                default:
                                                  return null;
                                              }
                                            })}
                        </div>
                      </div>

                      <div className="col-lg-6 col-md-12">
                        <div className="case-study-image">
                          <DynamicImage image={item.image} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="row justify-content-center mt-sm-5 mt-3">
            <div className="col-sm-10 text-center">
              {data?.contentDescription?.map((block, i) => {
                if (block.type === "paragraph") {
                  return (
                    <p key={i}>
                      {block.children.map((child, index) => {
                        if (child.bold) {
                          return <strong key={index}>{child.text}</strong>;
                        }
                        return <span key={index}>{child.text}</span>;
                      })}
                    </p>
                  );
                }
                return null;
              })}

            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default WhatWeDo
